<template>
  <div id="aside">
    <!-- <router-link to="/" class="backBlackBtn">Retour</router-link> -->
    <router-link to="/" class="logoLink">
      <img src="../assets/img/logos/VEGblanc.png" alt="Logo Gimont mon petit" />
    </router-link>

    <nav>
      <router-link to="/">Accueil</router-link>
      <router-link to="/a-propos.html" id="hlpHeaderNavLeftAbout"
        >&#192; propos</router-link
      >
      <router-link to="/liste.html" id="hlpHeaderNavLeftAdressbook"
        >Acteurs économiques</router-link
      >
      <router-link to="/contact.html" id="hlpHeaderNavLeftContact"
        >Contact</router-link
      >

      <a class="pocket" href="https://app.panneaupocket.com/ville/1884318079-gimont-32200" target="_blank" rel="noopener noreferrer">
            <img class="logoPocket" src="../assets/img/logos/logo-panneauPocket.png" alt="Logo de l'application Panneau Pocket">
          </a>
    </nav>
    <div class="phoneIcons">
      <a id="hplHeaderNavPhoneToggle1" @click="btnMenu = !btnMenu">
        <i class="fas fa-bars"></i>
      </a>
    </div>

    <div :class="phoneNav()">
      <a id="hplHeaderNavPhoneToggle2" @click="btnMenu = !btnMenu">
        <i class="fal fa-times"></i>
      </a>
      <nav>
        <router-link to="/">Accueil</router-link>
        <router-link to="/a-propos.html" id="hlpHeaderNavLeftAbout"
          >&#192; propos</router-link
        >
        <router-link to="/liste.html" id="hlpHeaderNavLeftAdressbook"
          >Acteurs économiques</router-link
        >
        <router-link to="/contact.html" id="hlpHeaderNavLeftContact"
          >Contact</router-link
        >
        <a class="linkPocket" href="https://app.panneaupocket.com/ville/1884318079-gimont-32200" target="_blank" rel="noopener noreferrer">
            <img class="logoPocketPhone" src="../assets/img/logos/logo-panneauPocket.png" alt="Logo de l'application Panneau Pocket">
          </a>

      </nav>
    </div>

    <!-- DISPLAY MSG -->
    <div id="DisplayMsg"></div>

    <!-- CONNECT USER -->
    <section id="connectUser" class="inscriptionPanel">
      <i
        class="fal fa-times btnClose"
        @click="showHideModal('connectUser')"
      ></i>
      <div class="etapesPanel">
        <router-link to="/" class="logoComm">
          <img
            src="../assets/img/logos/VEG2.png"
            alt="Logo Gimont mon petit commerce"
          />
        </router-link>

        <img
          src="../assets/img/content/Chatting-bro.png"
          alt="illustation commande depuis canapé"
          class="hideThousand"
        />

        <h3>Pas encore membre ?</h3>
        <a
          class="blackBtn"
          @click="
            showHideModal('signInUser');
            showHideModal('connectUser');
          "
          >Je m'inscris</a
        >
      </div>

      <div class="formDiv">
        <article>
          <h4>Connectez-vous</h4>
          <div>
            <label for>Votre Identifiant</label>
            <!-- 2019.1.115.45 -->
            <input
              id="ctl00_incLogin_tbxLogin"
              name="ctl00$incLogin$tbxLogin"
              class="riTextBox riEmpty"
              placeholder="Identifiant"
              type="text"
            />
          </div>

          <div class="connectPassBox">
            <label for>Votre Mot de passe</label>
            <input
              id="ctl00_incLogin_tbxPassword"
              name="ctl00$incLogin$tbxPassword"
              size="20"
              class="riTextBox riEmpty"
              type="password"
              placeholder="******"
            />
          </div>
          <div style="margin-top: 2rem">
            <button
              type="submit"
              name="ctl00$incLogin$btnSubmitLogin"
              value="Me Connecter"
              id="ctl00_incLogin_btnSubmitLogin"
              class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
            >
              <span class="rbText">Me Connecter</span>
              <input
                id="ctl00_incLogin_btnSubmitLogin_ClientState"
                name="ctl00_incLogin_btnSubmitLogin_ClientState"
                type="hidden"
              />
            </button>
          </div>
        </article>

        <div class="dejaMembre">
          <p>
            Pas encore membre ?
            <a
              @click="
                showHideModal('signInUser');
                showHideModal('connectUser');
              "
              >Inscrivez-vous</a
            >
          </p>
          <a class="backBtn" @click="showHideModal('connectUser')">Retour</a>
        </div>
      </div>
    </section>

    <!-- SIGN IN USER -->
    <section id="signInUser" class="inscriptionPanel">
      <div class="commercantPart">
        <i
          class="fal fa-times btnClose"
          @click="showHideModal('signInUser')"
        ></i>
        <router-link to="/" class="logoComm">
          <img
            src="../assets/img/logos/VEG2.png"
            alt="Logo Gimont mon petit commerce"
          />
        </router-link>
        <img
          src="../assets/img/content/Producthunt-bro.png"
          alt="commercant Gimont et sa moustache"
        />
        <p>
          Je suis un commerçant,
          <br />un producteur, un artisan... <br />et souhaite proposer mes
          services
        </p>
        <p>
          Je suis un particulier
          <br />et je souhaite voir les offres près de <br />chez moi
        </p>
      </div>

      <div class="formDiv">
        <article>
          <h4>
            Dites-nous tout pour faire
            <br />partie de la famille
          </h4>
          <div>
            <label>Vous êtes</label>
          </div>
          <div class="box">
            <section>
              <a
                class="blackBtn"
                @click="
                  showHideModal('signInUser');
                  showHideModal('signInUserCustomer');
                "
                >Particulier</a
              >
            </section>
            <section>
              <a
                class="blackBtn"
                @click="
                  showHideModal('signInUser');
                  showHideModal('signInUserSeller');
                "
                >Commerçant</a
              >
            </section>
          </div>
        </article>

        <div class="dejaMembre">
          <p>
            Déjà membre ?
            <a
              @click="
                showHideModal('signInUser');
                showHideModal('connectUser');
              "
              >Connectez-vous</a
            >
          </p>
          <a class="backBtn" @click="showHideModal('signInUser')">Retour</a>
        </div>
      </div>
    </section>

    <!-- SIGN IN USER SELLER -->
    <section id="signInUserSeller" class="inscriptionPanel">
      <div class="commercantPart">
        <i
          class="fal fa-times btnClose"
          @click="showHideModal('signInUserSeller')"
        ></i>
        <router-link to="/" class="logoComm">
          <img
            src="../assets/img/logos/VEG2.png"
            alt="Logo Gimont mon petit commerce"
          />
        </router-link>
        <img
          src="../assets/img/content/Mobile-payments-bro.png"
          alt="commercant Gimont et sa moustache"
        />
        <p>
          Je suis un commerçant,
          <br />un producteur, un artisan... <br />et souhaite proposer mes
          services
        </p>
      </div>

      <div class="formDiv">
        <article>
          <h4>
            Dites-nous tout pour faire
            <br />partie de la famille
          </h4>

          <div class="box">
            <section>
              <label for>Nom de l'entreprise / Producteur</label>
              <input
                id="ctl00_incLoginRegister_tbxSellerCompanyName"
                name="ctl00$incLoginRegister$tbxSellerCompanyName"
                class="riTextBox riEmpty"
                placeholder="Nom de votre entreprise"
                type="text"
              />
            </section>
          </div>
          <div class="box">
            <section>
              <label for>Type de service</label>
              <input type="text" list="filtres" placeholder="Type de service" />
              <datalist id="filtres">
                <option>option 1</option>
                <option>option 2</option>
                <option>option 3</option>
                <option>option 4</option>
              </datalist>
            </section>
          </div>

          <div class="box">
            <section>
              <label for>Adresse</label>
              <input
                id="ctl00_incLoginRegister_tbxSellerCompanyAddressStreet"
                name="ctl00$incLoginRegister$tbxSellerCompanyAddressStreet"
                class="riTextBox riEmpty"
                placeholder="Adresse de votre entreprise"
                type="text"
              />
            </section>
          </div>

          <div style="margin-top: 2rem">
            <button
              type="submit"
              name="ctl00$incLoginRegister$btnSubmitSellerRegister"
              value="Me Connecter"
              id="ctl00_incLoginRegister_btnSubmitSellerRegister"
              class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
            >
              <span class="rbText">Me Connecter</span>
            </button>
          </div>
        </article>

        <div class="dejaMembre">
          <p>
            Déjà membre ?
            <a
              @click="
                showHideModal('signInUserSeller');
                showHideModal('connectUser');
              "
              >Connectez-vous</a
            >
          </p>
          <a
            class="backBtn"
            @click="
              showHideModal('signInUserSeller');
              showHideModal('signInUser');
            "
            >Retour</a
          >
        </div>
      </div>
    </section>

    <!-- SIGN IN USER CUSTOMER -->
    <section id="signInUserCustomer" class="inscriptionPanel">
      <i
        class="fal fa-times btnClose"
        @click="showHideModal('signInUserCustomer')"
      ></i>
      <div class="etapesPanel">
        <router-link to="/" class="logoComm">
          <img
            src="../assets/img/logos/VEG2.png"
            alt="Logo Gimont mon petit commerce"
          />
        </router-link>

        <img
          src="../assets/img/content/Chatting-bro.png"
          alt="illustation commande depuis canapé"
        />

        <div class="blackCircles">
          <div class="bigcircle"></div>
          <div class="trait"></div>
          <div class="smcircle smcA"></div>
          <div class="trait"></div>
          <div class="smcircle smcB"></div>
          <div class="trait"></div>
          <div class="smcircle smcC"></div>
        </div>
      </div>

      <div class="formDiv">
        <article>
          <h4>
            Rejoignez-nous
            <br />et on vous tiens au jus
          </h4>

          <div class>
            <label for>Votre identifiant ou adresse email</label>
            <input
              id="ctl00_incLoginRegister_tbxCustomerAddressCity"
              name="ctl00$incLoginRegister$tbxCustomerAddressCity"
              class="riTextBox riEmpty fullInput"
              placeholder="Votre identifiant"
              type="text"
            />
          </div>

          <div class="box">
            <section>
              <label for>Mot de passe</label>
              <input
                id="ctl00_incLoginRegister_tbxCustomerEmail"
                name="ctl00$incLoginRegister$tbxCustomerEmail"
                class="riTextBox riEmpty"
                placeholder="********"
                type="password"
              />
            </section>
            <section>
              <label for>Confirmez le mot de passe</label>
              <input
                id="ctl00_incLoginRegister_tbxCustomerPassword"
                name="ctl00$incLoginRegister$tbxCustomerPassword"
                class="riTextBox riEmpty"
                placeholder="********"
                type="password"
              />
            </section>
          </div>
          <div class="boxCheckbox">
            <input type="checkbox" name id />
            <label for
              >J'ai lu les conditions d'utilisation et je les accepte</label
            >
          </div>

          <div style="margin-top: 2rem">
            <button
              type="submit"
              name="ctl00$incLoginRegister$btnSubmitCustomerRegister"
              value="Me Connecter"
              id="ctl00_incLoginRegister_btnSubmitCustomerRegister"
              class="RadButton RadButton_Default rbButton rbRounded rbIconButton"
            >
              <span class="rbText">Me Connecter</span>
              <input
                id="ctl00_incLoginRegister_btnSubmitCustomerRegister_ClientState"
                name="ctl00_incLoginRegister_btnSubmitCustomerRegister_ClientState"
                type="hidden"
              />
            </button>
          </div>
        </article>

        <div class="dejaMembre">
          <p>
            Déjà membre ?
            <a
              @click="
                showHideModal('signInUserCustomer');
                showHideModal('connectUser');
              "
              >Connectez-vous</a
            >
          </p>
          <a
            class="backBtn"
            @click="
              showHideModal('signInUserCustomer');
              showHideModal('signInUser');
            "
            >Retour</a
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Aside",
  data() {
    return {
      btnMenu: false,
    };
  },
  methods: {
    showHideModal(targetId) {
      let modal = document.getElementById(targetId);
      if (modal.style.display === "none" || modal.style.display === "") {
        modal.setAttribute("style", "display:flex");

        modal.animate(
          [{ transform: "translateX(-100vw)" }, { transform: "translateX(0)" }],
          {
            duration: 500,
          }
        );
      } else {
        setTimeout(() => {
          modal.setAttribute("style", "display:none");
          modal.setAttribute("style", "transform:translateX(-100vw)");
        }, 290);
        modal.animate(
          [{ transform: "translateX(0)" }, { transform: "translateX(-100vw)" }],
          {
            duration: 500,
          }
        );
      }
    },
    phoneNav() {
      let getClass;
      if (this.btnMenu == false) {
        getClass = "hide";
      } else {
        getClass = "phoneMenuAside";
      }
      return getClass;
    },
  },
};
</script>

<style scoped>
#aside {
  background: url(../assets/img/content/Customer-Survey-bro.png) no-repeat
    center 30%;
  background-size: contain;
  background-color: #d89747;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

#aside .logoLink img {
  width: 80%;
  margin-left: 10%;
  margin-top: 4rem;
}

#aside > img {
  width: 116%;
  max-height: 44%;
  object-fit: contain;
}

#aside nav {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10rem;
}

#aside nav a {
  margin: 0.5rem 0;
}

#aside nav a:hover:not(.blackBtn) {
  letter-spacing: 1px;
}

#aside nav .blackBtn {
  margin: 5rem 0;
}

#aside nav .blackBtn:hover {
  box-shadow: 0 0 0 2px black;
}

.backBlackBtn {
  position: absolute;
  left: 8px;
}

#hplHeaderNavPhoneLogin {
  display: none;
}
.dejaMembre p a {
  cursor: pointer;
}

.hide {
  display: none;
}

#aside .phoneMenuAside {
  width: 100%;
  position: fixed;
  background-color: #3c4652;
  top: 0;
  bottom: 0;
  z-index: 999;
}
#aside .phoneMenuAside nav {
  position: relative;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}
#aside .phoneMenuAside nav a {
  font-size: 1.5rem !important;
  margin-bottom: 2rem;
  border-bottom: 2px solid #d89747;
  padding-bottom: 1rem;
}


#aside .pocket {
  text-align: center;
}
#aside .logoPocket {
  width: 15%;
}
#aside a.linkPocket {
  text-align: center;
  width: 8%;
}
#aside .logoPocketPhone {
  width: 100%;
}

@media all and (max-width: 1000px) {
  #aside {
    background-image: none;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    bottom: auto;
    display: flex;
    flex-direction: row;
    position: relative;
    height: 20vh;
  }

  #aside .logoLink {
    width: 40%;
  }

  #aside .logoLink img {
    width: 80%;
    margin-top: 0;
  }

  #aside nav {
    display: none;
    /* display: flex;
     flex-direction: row;
     justify-content: space-between;
     width: 50%;
     margin: 0; */
  }

  #hlpHeaderNavLeftLogin {
    display: none;
  }

  #hplHeaderNavPhoneLogin {
    display: block;
  }
}

@media all and (max-width: 700px) {
  #aside {
    justify-content: center;
  }
  #aside .logoLink {
    width: 60%;
  }
}

@media all and (max-width: 450px) {
  #aside {
    height: 15vh;
  }
  #aside .logoLink {
    width: 80%;
  }
}
</style>